import React from 'react';
import Link from "gatsby-plugin-transition-link/AniLink"
import styled from 'styled-components'
import AnchorLink from 'react-anchor-link-smooth-scroll'

// Wayfx Assets
import wayfxFullLogo from "../images/wayfx-logo.svg"

const SiteFooter = styled.footer`
    padding: 56px 0;
    background: #F7F7F7;

    .container{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .row{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    h2{
        font-size: 14px;
        line-height: 13px;
        color: #131217;
        font-weight: 600;
        opacity: .6;
        text-transform: uppercase;
        letter-spacing: 1.08px;
        margin-bottom: 24px;
    }

    .col1{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-basis: 481px;

        .footer-logo{
            margin-bottom: 24px;
            line-height: 1;
        }

        p{
            margin: 0;
            font-size: 13px;
            line-height: 1;
            color: #999999;
        }

        ul.legal{
            display: flex;
            margin-top: 16px;

            li{
                a{
                    font-size: 13px;
                    line-height: 1;
                    color: #6F6F6F;

                    &:hover, &:focus{
                        color: var(--headings-color)
                    }
                }

                & + li{
                    margin-left: 16px;
                }
            }
        }
    }

    .col2{
        flex: 1 0 auto;
        
        p{
            display: none;
            margin: 0;
            font-size: 13px;
            line-height: 1;
            color: #999999;
        }

        ul{
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin: 0;
          padding: 0;
          list-style: none;

          li{
            margin: 0;
            line-height: 1;

            & + li{
              margin-left: 24px;
            }

            a{
                text-decoration: none;
                color: #0D0F0F;
                transition: all 0.2s ease-in-out;
                display: block;
                font-weight: 500;
                font-size: 16px;

                &:hover{
                    text-decoration: underline;
                }
            }
          }
        }
    }

    @media all and (max-width: 600px) {
        padding: 56px 0 48px;

        .row{
            flex-direction: column;
        }

        .col1{
            flex-basis: auto;
            width: 100%;
            margin-right: 0;
            

            .footer-logo{
                margin: 0 auto 32px;
            }

            p{
                display: none;
            }
        }

        .col2{
            ul{
                flex-direction: column;

                li{
                    & + li{
                        margin-left: 0;
                        margin-top: 16px;
                    }

                    a{
                        font-weight: normal;
                    }
                }
            }
            p{
                display: block;
                text-align: center;
                margin-top: 40px;
            }
        }
    }
`;

const Footer = () => {
    return (
      <SiteFooter>
        <div className="container">
          <div className="row">
            <div className="col1">
              <Link to="/" className="footer-logo">
                <img src={wayfxFullLogo} alt="Wayfx" />
              </Link>

              <p>Copyright &copy; 2021 Wayfx</p>
            </div>
            <div className="col2">
              <ul>
                <li><AnchorLink offset='55' href="#growth">Ecommerce Growth Upgrade</AnchorLink></li>
                <li><a href="https://growaov.com/?ref=Wayfx" target="_blank" rel="noreferrer">GrowAOV</a></li>
                <li>
                  <a href="https://form.typeform.com/to/lf6sAz4T" target="_blank" rel="noreferrer">Contact Us</a>
                </li>
              </ul>
              <p>Copyright &copy; 2021 Wayfx</p>
            </div>
          </div>
        </div>
      </SiteFooter>
    )
}

export default Footer